<div class="mb-3">
  @if (appealsService.messageAppealFact == 'SUCCESS_CONTINUANCE') {
  <nh-alert type="success" [isOpen]="appealsService.showMessageAppealFact">
    @if (appealsService.messageAppealFact == 'SUCCESS_CONTINUANCE') {
    <div class="col message">
      <span [innerHtml]="'SUCCESS_APEEAL_FACT_SUBMITTED' | globalTranslate">
      </span>
    </div>
    }
  </nh-alert>
  } @if (appealsService.messageAppealFact == 'ERROR_MESSAGE') {
  <nh-alert type="warning" [isOpen]="appealsService.showMessageAppealFact">
    @if (appealsService.messageAppealFact == 'ERROR_MESSAGE') {
    <div class="col message">
      <span>{{ "ERROR_APEEAL_FACT_SUBMITTED" | globalTranslate }}</span>
    </div>
    }
  </nh-alert>
  }
  <div class="bg-custom">
    <div class="container">
      <div>
        <h1 class="section-header">
          {{ "APPEAL_FACT_FORM_TITLE" | globalTranslate }}
        </h1>
        <hr />
        <div>
          <p class="mb-4">{{ "SUBMISSION_MSG" | globalTranslate }}</p>
        </div>
        <div>
          <form [formGroup]="appealFactSubmissionForm">
            <nh-field
              [attr.aria-required]="true"
              class="textcolor"
              id="app_con_submittedby"
              [mandatory]="true"
              label="{{ 'SUBMITTEDBY_CONTINUANCE' | globalTranslate }}"
              [attr.aria-label]="'SUBMITTEDBY_CONTINUANCE' | globalTranslate"
            >
              <div>
                <p class="note_padding">
                  {{ "FACT_SUBMISSION_NOTE_SUBMITTEDBY" | globalTranslate }}
                </p>
              </div>
              <input
                type="text"
                class="form-control"
                name="submittedBy"
                formControlName="submittedBy"
                [attr.aria-label]="'SUBMITTEDBY_CONTINUANCE' | globalTranslate"
                autofocus="true"
                maxlength="30"
              />
            </nh-field>
            <p></p>

            <nh-field
              [attr.aria-required]="true"
              [isRow]="true"
              [mandatory]="true"
              label="{{ 'PHONE_NUMBER_WITHDRAWAL' | globalTranslate }}"
              [attr.aria-label]="'PHONE_NUMBER_WITHDRAWAL' | globalTranslate"
            >
              <input
                type="text"
                name="phoneNumber"
                formControlName="phoneNumber"
                [attr.aria-label]="'PHONE_NUMBER_WITHDRAWAL' | globalTranslate"
                class="form-control mt-2"
                mask="000-000-0000"
                placeholder="XXX-XXX-XXXX"
              />
            </nh-field>

            <nh-field
              [attr.aria-required]="true"
              class="textcolor"
              id="app_con_relationship"
              [mandatory]="true"
              label="{{ 'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate }}"
              [attr.aria-label]="
                'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate
              "
            >
              <div>
                <p class="rel_pad">
                  {{ "APPEAL_FACT_NOTE_RELATIONSHIP" | globalTranslate }}
                </p>
              </div>
              <nh-count>
                <textarea
                  maxlength="2000"
                  class="form-control"
                  name="relationshipWithAppellant"
                  formControlName="relationshipWithAppellant"
                  [attr.aria-label]="
                    'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate
                  "
                  rows="5"
                  autofocus="true"
                >
                </textarea>
              </nh-count>
            </nh-field>

            <nh-field
              [attr.aria-required]="true"
              class="textcolor"
              id="app_con_comments"
              [mandatory]="true"
              label="{{ 'APPEAL_FACT_RESPONSE' | globalTranslate }}"
              [attr.aria-label]="'APPEAL_FACT_RESPONSE' | globalTranslate"
            >
              <div>
                <p
                  class="rel_pad"
                  [innerHtml]="'FACT_RESPONSE_NOTE' | globalTranslate"
                ></p>
              </div>
              <nh-count>
                <textarea
                  maxlength="2000"
                  class="form-control"
                  name="appealFactResponse"
                  formControlName="appealFactResponse"
                  [attr.aria-label]="'APPEAL_FACT_RESPONSE' | globalTranslate"
                  rows="5"
                  autofocus="true"
                >
                </textarea>
              </nh-count>
            </nh-field>
          </form>

          <div class="row my-1">
            <div class="col-md-12">
              <div
                class="row mt-3 text-center py-3"
                style="padding-top: 0.5rem !important"
              >
                <div class="ms-3">
                  <button
                    id="continue"
                    class="btn d-grid btn-secondary btn-width"
                    [disabled]="appealsService.showMessageAppealFact"
                    (click)="
                      onSubmit(
                        this.appealFactSubmissionForm.controls,
                        this.translatedLang
                      )
                    "
                    [disabled]="!isFormValid()"
                  >
                    {{ "SUBMIT_APPEAL_FACT" | globalTranslate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row my-5">
    <div class="col-md-12">
      <div class="row mt-3 text-center py-4 withdrawl-exit">
        <div class="ms-3">
          <button
            id="continue"
            class="btn d-grid btn-secondary btn-width"
            (click)="goToAppealsDashboard()"
          >
            {{ "EXIT" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>